'use client';
import * as React from 'react';

var FieldNotifVariant;
(function (FieldNotifVariant) {
    FieldNotifVariant["DANGER"] = "danger";
    FieldNotifVariant["WARNING"] = "warning";
    FieldNotifVariant["INFO"] = "info";
    FieldNotifVariant["SUCCESS"] = "success";
})(FieldNotifVariant || (FieldNotifVariant = {}));
var FieldNotifStyle = /** @class */ (function () {
    function FieldNotifStyle() {
        this.type = "";
    }
    FieldNotifStyle.prototype.build = function () {
        var style = "";
        if (this.type === FieldNotifVariant.DANGER) {
            style += "text-sm text-red-600";
        }
        else if (this.type === FieldNotifVariant.WARNING) {
            style += "text-sm text-yellow-600";
        }
        else if (this.type === FieldNotifVariant.INFO) {
            style += "text-sm text-blue-600";
        }
        else if (this.type === FieldNotifVariant.SUCCESS) {
            style += "text-sm text-green-600";
        }
        return style;
    };
    FieldNotifStyle.prototype.setVariant = function (type) {
        this.type = type;
        return this;
    };
    return FieldNotifStyle;
}());

function Field(props) {
    return (React.createElement(React.Fragment, null, props.children));
}
var styleBuilder = new FieldNotifStyle();
function FieldNotif(props) {
    var _a = props.variant, variant = _a === void 0 ? FieldNotifVariant.DANGER : _a;
    var classNames = styleBuilder.setVariant(variant).build();
    return (React.createElement(React.Fragment, null, props.children &&
        React.createElement("span", { className: classNames }, props.children)));
}

export { Field, FieldNotif, FieldNotifVariant };
